import React from 'react'
import './Wwo.css'
import CountUpOnScroll from '../../Home/About/ScrollCounter'
import cs from '../../../../assets/img/globe.svg'
import pd from '../../../../assets/img/project_delivered.svg'
import te from '../../../../assets/img/te.svg'
import yoe from '../../../../assets/img/yoe.svg'
import cwad from '../../../../assets/img/cwad.svg'
import ecde from '../../../../assets/img/ecde.svg'
import swad from '../../../../assets/img/swad.svg'
import pwa from '../../../../assets/img/pwa.svg'
import wasm from '../../../../assets/img/wasm.svg'

function Wwo() {

  const wwolist = [
    {
      icon:cwad,
      title: "Custom Web App Development",
      desc: "At 360 Bytes, we excel in custom web app development, transforming unique business requirements into powerful digital solutions. Our experienced team meticulously crafts web applications tailored to meet the specific needs of your business, ensuring functionality, scalability, and security. By leveraging cutting-edge technologies, we deliver bespoke applications that drive efficiency and enhance user engagement."
    },
    {
      icon:ecde,
      title: "E-Commerce Development",
      desc: "Our expertise in e-commerce development enables us to create robust and user-friendly online stores that drive sales and provide an exceptional shopping experience. From intuitive product catalogs to secure payment gateways, 360 Bytes ensures that your e-commerce platform is optimized for performance, reliability, and scalability, helping your business grow in the competitive online marketplace."
    },
    {
      icon:swad,
      title: "SaaS Web App Development",
      desc: "360 Bytes specializes in developing SaaS (Software as a Service) web applications that deliver high-performance solutions to meet diverse business needs. Our team is proficient in building scalable and secure SaaS applications that are easy to deploy and manage. We provide end-to-end services, from initial concept to deployment, ensuring that your SaaS application is tailored to deliver maximum value to your users."
    },
    {
      icon:pwa,
      title: "Progressive Web App Development",
      desc: "Embrace the future of web applications with our Progressive Web App (PWA) development services. 360 Bytes creates PWAs that offer the best of both web and mobile apps, providing a fast, reliable, and engaging user experience. Our PWAs are designed to work seamlessly across all devices and platforms, ensuring your users have consistent access to your services anytime, anywhere."
    },
    {
      icon:wasm,
      title: "Web App Support and Maintenance",
      desc: "At 360 Bytes, we believe in building long-term relationships with our clients. Our web app support and maintenance services ensure that your application remains functional, secure, and up-to-date. We offer regular updates, performance optimizations, and prompt issue resolution, providing you with peace of mind and allowing you to focus on your core business operations."
    },
  ]

  return (
    <section className='wwo-sec'>
        <div className='container'>
            <div className='pht-sec'>
                <ul>
                    <li><img src={cs} alt='Countries Served' width={64} height={64} loading="lazy"/><h4> <CountUpOnScroll end={25} />+</h4><p>Countries Served</p></li>
                    <li><img src={pd} alt='Projects Delivered' width={64} height={64} loading="lazy"/><h4> <CountUpOnScroll end={200} />+</h4><p>Projects Delivered</p></li>
                    <li><img src={te} alt='Tech Enthusiast' width={64} height={64} loading="lazy"/><h4> <CountUpOnScroll end={120} />+</h4><p>Tech Enthusiast</p></li>
                    <li><img src={yoe} alt='Years of Experience' width={64} height={64} loading="lazy"/><h4> <CountUpOnScroll end={10} />+</h4><p>Years of Experience</p></li>
                </ul>
            </div>
            <div className='wwo-sec1'>
            <h3>What We Offer</h3>
              <ul>
                {
                  wwolist.map((Wwo, index)=>(
                    <li key={index}>
                      <div className='wwo-icon'><img src={Wwo.icon} alt={Wwo.title} width={64} height={64}/></div>
                      <h4>{Wwo.title}</h4> 
                      <p>{Wwo.desc}</p>  
                    </li>
                  ))
                }
                   
              </ul>    
            </div> 
        </div>
    </section>
  )
}

export default Wwo
